var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F9FA",
  d: "M1.167 0h13.666C15.477 0 16 .538 16 1.2v9.6c0 .318-.123.624-.342.848a1.15 1.15 0 0 1-.825.352H1.167a1.15 1.15 0 0 1-.825-.351A1.22 1.22 0 0 1 0 10.8V1.2C0 .538.523 0 1.167 0M1 3.025V10.8a.17.17 0 0 0 .167.171h13.666a.16.16 0 0 0 .118-.05A.17.17 0 0 0 15 10.8V3.025L8.653 7.437a1.14 1.14 0 0 1-1.306 0zM1 1.2v.584l6.907 4.8a.16.16 0 0 0 .186 0L15 1.784V1.2a.17.17 0 0 0-.049-.121.17.17 0 0 0-.118-.05H1.167a.16.16 0 0 0-.118.05A.17.17 0 0 0 1 1.2"
})));
export default SvgMail;